<template>
    <div class="shipdetailBox detailBox">
        <div class="flexpane_header">
            <div class="flexpane__subtitle flex aic">
                <p>SO : {{ ObjPopupData.shipData.Shiptask_name }}</p>
                <i class="iconfont icon-fuzhicopy22 ml-5 f16"
                    @click="copyText(ObjPopupData.shipData.Shiptask_name)"></i>
            </div>
            <el-icon @click="Closedetail">
                <CloseBold />
            </el-icon>
        </div>
        <div class="detail_body">
            <div class="headerInfo">
                <p class="fwb mb-10 f16">{{ $t("slack.BasicInformation") }}</p>
                <p>
                    <span>{{ $t("slack.Sales") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.sale_name || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.Contacts") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.contact || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.CountryRegion") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.country || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.DeliveryTime") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.Shipdatetime || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.Doc") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.OddNumbers || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.AWB") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.TransferNo || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.Way") }}:</span>
                    <span class="f16">{{ ObjPopupData.shipData.shipping_way || '-' }}</span>
                </p>
                <p class="mt-5">
                    <span>{{ $t("slack.ShippingFee") }}:</span>
                    <span class="f16">{{ currencType(ObjPopupData.shipData.currency) }}{{
                        ObjPopupData.shipData.Fee || '-' }}</span>
                </p>
            </div>
            <div class="itemBox ModelBox">
                <div class="ModelNumDiv flex aic">
                    <p class="fwb f33 f16">
                        {{ $t("slack.items") }} ({{ convertNum(ObjPopupData.shipData.dataList.length) }})
                    </p>
                    <div class="CurrentBox flex aic jc-sb">
                        <p>
                            <span>{{ ObjPopupData.shipData.currency || 'CNY' }}</span>
                            <span>{{ $t("slack.Rate") }}:</span>
                            <span>{{ ObjPopupData.shipData.rate }}</span>
                        </p>
                        <i class="iconfont icon-xiangxiajixu f16 000" v-if="Isexpand" @click="Isexpand = !Isexpand"></i>
                        <i class="iconfont icon-xiangxiajixu f16 000" v-else style="transform: rotate(180deg)"
                            @click="Isexpand = !Isexpand"></i>
                    </div>
                </div>
                <div class="ModelList">
                    <div class="Models" v-for="(model, index) in ObjPopupData.shipData.dataList" :key="index">
                        <div class="Model" :key="index">
                            <div class="modelDiv">
                                <div class="ModelName flex aic jc-sb">
                                    <div class="flex aic">
                                        <el-tooltip class="box-item" effect="dark" :content="model.Model"
                                            :disabled="isShowTooltip" placement="bottom">
                                            <p class="fwb" @mouseenter="getWidth($event)">
                                                {{ model.Model }}
                                            </p>
                                        </el-tooltip>
                                        <i class="iconfont icon-dianchi" style="color:rgb(17, 145, 7)"
                                            v-if="ObjPopupData.shipData.is_charged != 0"></i>
                                    </div>
                                    <p> x {{ model.Qty }}</p>
                                </div>
                            </div>
                            <div class="infoDiv" v-if="Isexpand">
                                <p>{{ $t("slack.Brand") }}: {{ model.Brand || '-' }}</p>
                                <p>
                                    {{ $t("slack.Condition") }}: {{ model.Condition || '-' }}
                                </p>
                                <p>{{ $t("slack.Leading") }}: {{ model.Leading || '-' }}</p>
                                <p>{{ $t("slack.Weight") }}:{{ model.Weight || '-' }} {{ model.weight_unit }}</p>
                                <p>{{ $t("slack.Purchaser") }}: {{ model.Purchaser || '-' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="itemBox" v-if="ObjPopupData.shipData.CartonList && ObjPopupData.shipData.CartonList.length">
                <p class="fwb f33 mb-10 f16">{{ $t("slack.Cartons") }} ({{
                    convertNum(ObjPopupData.shipData.CartonList.length) }})</p>
                <div class="CartonList">
                    <div class="Carton" v-for="(Carton, index) in ObjPopupData.shipData.CartonList" :key="index">
                        <p class="fwb f33 mb-10 f16">{{ $t("slack.Carton") }}: {{ convertNum(index + 1) }}</p>
                        <p>{{ $t("slack.Size") }}: {{ Carton.long }}*{{ Carton.wide }}*{{ Carton.high }} cm</p>
                        <p>{{ $t("slack.VolumeWeight") }}: {{ Carton.volumeWeight }}kg,{{ $t("slack.GrossWeigh") }}: {{
                            Carton.netWeight }}kg</p>
                    </div>
                </div>
            </div>
            <div class="itemBox" v-if="ObjPopupData.shipData.img_path.length">
                <p class="fwb f33 mb-10 f16">{{ $t("slack.PackingPictures") }} ({{
                    convertNum(ObjPopupData.shipData.img_path.length) }})</p>
                <div class="imgList flex fww">
                    <div class="imgDiv pr-20" v-for="(imgItem, index) in ObjPopupData.shipData.img_path" :key="index" @click="PreviewImage(imgItem.file_path)">
                        <img :src="imgItem.file_path" />
                    </div>
                </div>
            </div>
            <div class="ml-20 mr-20 pt-15 pb-15" v-if="ObjPopupData.shipData.description">
                <p class="fwb f33 f16">{{ $t("slack.Remarks") }}</p>
                <p>{{ ObjPopupData.shipData.description }}</p>
            </div>
        </div>
        <!-- 预览图片 -->
        <Preview :showVisible="showVisible" :PreviewFile="PreviewFile" @closePreview="showVisible = false" />
    </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import {  HomeStore } from "../../index";
import { currencType, convertNum } from "../../utils/index.js"
import Preview from "../messageList/Preview.vue"
import useClipboard from "vue-clipboard3";
import { ElMessage, ElMessageBox } from "element-plus";
import i18n from "@/assets/lang";
const { toClipboard } = useClipboard(); //剪切板
const copyText = (info) => {
    try {
        toClipboard(info);
        ElMessage({
            message: i18n.global.t("Order.orderReplication"),
            type: "success",
        });
    } catch (e) {
        console.error(e);
    }
};
const isShowTooltip = ref("")
function getWidth(event) {
    if (event.target.scrollWidth > event.target.clientWidth) {
        isShowTooltip.value = false;
    } else {
        isShowTooltip.value = true;
    }
}
const Isexpand = ref(false)
const ObjPopupData = computed(() => {
    return HomeStore().ObjPopupData
})
const showVisible = ref(false)
const PreviewFile = ref("")
function PreviewImage(file) {
    showVisible.value = true;
    PreviewFile.value = file;
}
function Closedetail() {
    HomeStore().isDetail = false;
    HomeStore().showDetail = false;
}
</script>
<style lang="less" scoped>
.shipdetailBox {
    .CurrentBox {
        flex: 1;
        padding-left: 23px;

        p {
            padding: 5px;
            background-color: #a2acbb;
            color: #fff;
            border-radius: 4px;
        }

        i {
            margin-left: 5px;
        }
    }

    .ModelList {
        margin-top: 10px;
        max-height: 350px;
        overflow: auto;

        .Models {
            background: #f2f4f7;
            padding: 5px 10px;
            border-radius: 4px;
            margin-bottom: 10px;

            .stateBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 5px;

                .state_text {
                    color: #555;
                    margin-left: 5px;
                }
            }

            .Model {
                margin-bottom: 5px;

                .modelDiv {
                    display: flex;
                    justify-content: space-between;

                    .ModelName {
                        font-weight: 700;
                        margin-bottom: 5px;
                        flex: 1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                        .PiQty {
                            flex: 1;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                }

                .infoDiv {
                    p {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        margin-top: 3px;
                    }
                }
            }
        }

        .Models:last-child {
            margin-bottom: 0;
        }

        .Model:last-child {
            margin-bottom: 0;
        }

        .NoBottom {
            margin-bottom: 0 !important;
        }
    }

    .CartonList {
        .Carton {
            border-bottom: dashed 1px #d7e2ed;
            padding: 10px;
            background-color: #F2F4F7;
        }

        .Carton:last-child {
            border-bottom: none;
        }
    }

    .imgList {
        .imgDiv img {
            width: 72px;
            height: 72px;
            border-radius: 4px;
        }
    }
}
</style>